module.exports = __webpack_public_path__ + "static/img/Bachelor_010217.cf510d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010217.jpg
// module id = 121
// module chunks = 0